import module from 'viaticos/module.js'
import template from './template.html'
import * as moment from 'moment'

export class ViaticosAutorizarComponent {
  busqueda

  $onChanges (changes) {
    if (changes.busqueda) {
      this.busqueda = {
        fechaInicial: changes.busqueda.currentValue.fechaInicial || null,
        fechaFinal: changes.busqueda.currentValue.fechaFinal || moment().add(1, 'months').toDate(),
      }
    }
  }
}

module.component('viaticosAutorizar', {
  controller: ViaticosAutorizarComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/autorizar/component.js